"use client";

import type React from "react";
import { useContext as useContextImpl, useDebugValue } from "react";

/**
 * Creates a named useContext hook that ensures usage within a Context.Provider
 * @param hookName name of the hook
 * @param Context React Context object
 * @returns a wrapped useContext hook that ensures it is used within a Context.Provider
 */
export function createNamedContextHook<S>(hookName: string, Context: React.Context<S | undefined>): () => S {
  return function useContext() {
    useDebugValue(hookName);
    const value = useContextImpl(Context);
    if (value === undefined) throw new Error(`${hookName} must be used within ${Context.displayName}.Provider`);
    return value;
  };
}